import React, {
  useEffect,
  useState,
  useRef,
  useContext,
  forwardRef,
} from 'react';
import ChatBar from '../ChatBar';
import ChatBody from '../ChatBody';
import ChatFooter from '../ChatFooter';
// import ToolbarIcons from '../../../../public/icons/toolbar';
// import { AdminContext } from '../../../../context/AdminContext';
// import { useRouter } from 'next/router';
import { AdminContext } from '../../../context/AdminContext';
import ToolbarIcons from '../../../icons/toolbar';
import Api from '../../../api';
import CenterModal from '../../../components/CenterModal';
import Loader from '../../../components/Loader';
import styles from './styles.module.css';
import ChooseBackground from '../../../functions/chooseBackground';
import SHARED from '../../../constants';

const ChatPage = forwardRef((props, ref) => {
  const {
    themeColor,
    privateUsers,
    setPrivateUsers,
    userChannelId,
    setUserChannelId,
    // activeUser,
    setUpdateSocket,
    setopenBox,
    content,
    setActiveUser,
    videoChatSize,
    showFirstMessage,
    setShowFirstMessage,
    sharedUserClicked,
    setSharedUserClicked,
    bg,
    backScale,
    showAbsolute,
    previousChannelId,
    setPreviousChannelId,
    direction,
    isMobile,
    // setUserChannelId,
  } = useContext(AdminContext);
  // const [previousChannelId, setPreviousChannelId] = useState('');

  // const [dragActive, setDragActive] = useState(false);
  // const [message, setMessage] = useState('');
  // console.log(
  //   'activeUser',
  //   activeUser,
  //   activeUser?.users?.[0]?.channelUser?.pins?.length
  // );
  console.log('sharedUserClciked', sharedUserClicked);
  // const [messages, setMessages] = useState([]);
  // const [typingStatus, setTypingStatus] = useState('');
  // const [loadingFile, setLoadingFile] = useState(false);
  // const [loadingFileButton, setLoadingFileButton] = useState(false);

  // const [loadingOldMessages, setLoadingOldMessages] = useState(false);
  // const lastMessageRef = useRef(null);
  // const [selected, setSelected] = useState(false);

  // const [showUsers, setShowUsers] = useState(true);
  // // const [users, setUsers] = useState([]);
  // const router = useRouter();
  // const [count, setCount] = useState(0);
  // const [privateUsers, setPrivateUsers] = useState([]);
  // // const [users, setUsers] = useState([]);
  // const lastMessageRef = useRef(null);

  console.log('props?.chatTypePrivate', props?.chatTypePrivate);
  useEffect(() => {}, [props?.activeUser]);
  // useEffect(() => {
  //   // if (socket) {
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.on('private:messageResponse', (data) => {
  //       // setMessages((perv) => [...perv, data]);
  //       console.log('mahsaaaa , ', messages, data);
  //       setMessages([...messages, data]);

  //       setLoadingFile(false);
  //       setLoadingFileButton(false);
  //       setSelected(true);
  //     });
  //   } else {
  //     ref?.current?.on('multiple:messageResponse', (data) => {
  //       setMessages([...messages, data]);
  //       setLoadingFile(false);
  //       setLoadingFileButton(false);
  //       setSelected(true);
  //     });
  //   }
  //   // }
  // }, [ref, messages]);
  // console.log('mahsaaaa se , ', props?.messages);

  const unBlockFunction = () => {
    // Api.blockUser(activeUser?.users?.[0]?.channelUserId)
    //   .then((res) => {
    //     setUpdateSocket('user');
    //     setopenBox(false);
    //   })
    //   .catch((err) => {});
    ref?.current?.emit(
      'private:blockUser',
      {
        uuid: props?.activeUser?.users?.[0]?.channelUser?.uuid,
        typeId: props?.activeUser?.typeId,
        roomId: props?.activeUser?.id,
      },
      (data) => {
        // setUpdateSocket('user');
        // setopenBox(false);
        setActiveUser({
          ...props?.activeUser,
          block: props?.activeUser.block == 1 ? 0 : 1,
        });
        props?.setServerError('');
      }
    );
  };
  // useEffect(() => {
  //   console.log('userchannelid', userChannelId);
  //   initialFunction();
  // }, [userChannelId]);

  // const initialFunction = () => {
  //   if (window.innerWidth < 600) {
  //     setShowUsers(false);
  //   }

  //   setLoadingOldMessages(true);
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.on('private:messageListResponse', (response) => {
  //       console.log('chatttttttttt ====', response);
  //       setMessages(messages.concat(response?.response));
  //       setLoadingOldMessages(false);
  //     });
  //     // Api.userMessageList(
  //     //   userChannelId
  //     //   // , { params: { channelId: userChannelId } }
  //     // )
  //     //   .then((res) => {
  //     //     // setMessages(messages.concat(res?.data?.response));
  //     //     const newarray = messages.concat(res?.data?.response);
  //     //     setMessages(newarray);
  //     //     setLoadingOldMessages(false);
  //     //   })
  //     //   .catch((err) => {
  //     //     setServerError(err?.response?.data?.message);
  //     //   });
  //   } else {
  //     ref?.current?.on('multiple:messageListResponse', (response) => {
  //       setMessages(messages.concat(response?.response));
  //       setLoadingOldMessages(false);
  //     });
  //     // Api.videoMessageList(
  //     //   uuid
  //     //   // channelId, { params: { uuid: uuid } }
  //     // )
  //     //   .then((res) => {
  //     //     const newarray = messages.concat(res?.data?.response);
  //     //     setMessages(newarray);
  //     //     setLoadingOldMessages(false);
  //     //   })
  //     //   .catch((err) => {
  //     //     setServerError(err?.response?.data?.message);
  //     //   });
  //   }
  //   lastMessageRef.current?.scrollIntoView({ behavior: 'smooth' });
  // };
  // useEffect(() => {
  //   // if (socket) {
  //   if (props?.chatTypePrivate) {
  //     ref?.current?.on(
  //       'private:typingResponse',
  //       // { type: '' },
  //       // { channelId: userChannelId },
  //       (data) => {
  //         console.log('type==', data);
  //         setTypingStatus(data);
  //       }
  //     );
  //   } else {
  //     ref?.current?.on('multiple:typingResponse', (data) =>
  //       setTypingStatus(data)
  //     );
  //   }
  //   // }
  // }, [ref]);

  useEffect(() => {
    // if (loadingOldMessages) {
    props?.lastMessageRef?.current?.scrollIntoView({ behavior: 'smooth' });
    // }
  }, [props?.loadingOldMessages]);

  useEffect(() => {
    // 👇️ scroll to bottom every time messages change
    // lastMessageRef.current?.scrollIntoView({ behavior: 'smooth' });
    let container = document.getElementById('messageContainer');
    console.log(
      'container==',
      container?.scrollHeight,
      container?.clientHeight,
      container?.scrollTop,
      Math.abs(
        container?.scrollHeight - container?.clientHeight - container?.scrollTop
      )
    );
    if (
      Math.abs(
        container?.scrollHeight - container?.clientHeight - container?.scrollTop
      ) < 350
    ) {
      props?.lastMessageRef?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [props?.messages]);

  // console.log('filessss', messages);
  useEffect(() => {}, [showFirstMessage]);
  // console.log('serverError', props?.serverError);
  // console.log('showFirstMessage==', showFirstMessage);
  // console.log('showUsers', props?.showUsers, showAbsolute);

  return (
    <div className="chat relative chatPage" id="chatpage">
      {!props?.onlineStatus && (
        <div className={`${'connectionError'}`}>{content.offlineText}</div>
      )}
      {/* {router?.pathname?.includes('/channel') == false && ( */}
      <ChatBar
        ref={ref}
        showUsers={props?.showUsers}
        setShowUsers={props?.setShowUsers}
        users={props?.users}
        setUsers={props?.setUsers}
        chatTypePrivate={props?.chatTypePrivate}
        setMessages={props?.setMessages}
        // privateUsers={props?.privateUsers}
        activeUser={props?.activeUser}
        setActiveUser={props?.setActiveUser}
        setReplyValue={props?.setReplyValue}
        content={props?.content}
        onlineStatus={props?.onlineStatus}
        setLoadingFileButton={props?.setLoadingFileButton}

        // setPrivateUsers={props?.setPrivateUsers}
      />
      {/* )} */}
      {userChannelId?.length != 0 ? (
        <div
          className={`chat__main relative seperatorTop ${
            !isMobile &&
            (direction == 'rtl' ? 'seperatorRight' : 'seperatorLeft')
          }`}
        >
          {/* {router?.pathname?.includes('/channel') == false && ( */}
          {/* <div
          className={`userButton ${
            themeColor == 'white' ? 'whiteThemeBoxShadow' : 'grayThemeBoxShadow'
          }`}
          onClick={() => {
            props?.setShowUsers(!props?.showUsers);
          }}
        >
          <ToolbarIcons.usersIcon
            width={'24px'}
            height={'24px'}
            className={`cursor-pointer`}
          />
        </div> */}
          {/* )} */}

          <div
            // className={` ${
            //   ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
            // }`}
            style={{
              //   backgroundImage: `url(${ChooseBackground(bg)?.src})`,
              //   // backgroundSize: '200px',
              //   // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
              //   backgroundSize: ChooseBackground(bg)?.cover
              //     ? 'cover'
              //     : `${SHARED.maxBgScale * backScale}px`,
              height: `100%`,
              position: 'relative',
            }}
          >
            <div
              className={` ${styles.absoluteBg} darkMode ${
                ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
              }`}
              style={{
                backgroundImage: `url(${ChooseBackground(bg)?.src})`,
                // backgroundSize: '200px',
                // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
                backgroundSize: ChooseBackground(bg)?.cover
                  ? 'cover'
                  : `${SHARED.maxBgScale * backScale}px`,
                // height: `100%`,
              }}
            ></div>
            <div className={`messageContainerShadow  `}>
              {!showFirstMessage ? (
                <ChatBody
                  ref={ref}
                  messages={props?.messages}
                  typingStatus={props?.typingStatus}
                  setTypingStatus={props?.setTypingStatus}
                  lastMessageRef={props?.lastMessageRef}
                  loadingOldMessages={props?.loadingOldMessages}
                  chatTypePrivate={props?.chatTypePrivate}
                  count={props?.count}
                  setCount={props?.setCount}
                  setMessages={props?.setMessages}
                  setLoadingOldMessages={props?.setLoadingOldMessages}
                  setServerError={props?.setServerError}
                  uuid={props?.uuid}
                  channelId={props?.channelId}
                  replyValue={props?.replyValue}
                  setReplyValue={props?.setReplyValue}
                  firstMessageRef={props?.firstMessageRef}
                  content={props?.content}
                  direction={props?.direction}
                  // setMessages={props?.setMessages}
                  // privateUsers={props?.privateUsers}
                  activeUser={props?.activeUser}
                  setActiveUser={props?.setActiveUser}
                  setReplyValue={props?.setReplyValue}
                  onlineStatus={props?.onlineStatus}
                  handleDrag={props?.handleDrag}
                  handleDrop={props?.handleDrop}
                  dragActive={props?.dragActive}
                  changeMessageFunction={props?.changeMessageFunction}
                  activeUser={props?.activeUser}
                  handleSendMessage={props?.handleSendMessage}
                  sendFunction={props?.sendFunction}
                  notTyping={props?.notTyping}
                  message={props?.message}
                  setMessage={props?.setMessage}
                  handleDrag={props?.handleDrag}
                  handleDrop={props?.handleDrop}
                  getUserFunction={props?.getUserFunction}
                  previousChannelId={previousChannelId}
                  setPreviousChannelId={setPreviousChannelId}
                  setSharedUserClicked={setSharedUserClicked}
                />
              ) : (
                <div className={`infinitContainer relative`}></div>
              )}

              {props?.activeUser?.block == 0 && !showFirstMessage ? (
                <>
                  {props?.activeUser?.users?.[0]?.channelUser?.statusId !=
                    5 && (
                    <ChatFooter
                      ref={ref}
                      setServerError={props?.setServerError}
                      fileType={props?.fileType}
                      loadingFile={props?.loadingFile}
                      setLoadingFile={props?.setLoadingFile}
                      loadingFileButton={props?.loadingFileButton}
                      setLoadingFileButton={props?.setLoadingFileButton}
                      setLoadingOldMessages={props?.setLoadingOldMessages}
                      setTypingStatus={props?.setTypingStatus}
                      users={props?.users}
                      chatTypePrivate={props?.chatTypePrivate}
                      replyValue={props?.replyValue}
                      setReplyValue={props?.setReplyValue}
                      content={props?.content}
                      setMessages={props?.setMessages}
                      fromSearch={false}
                      handleSendMessage={props?.handleSendMessage}
                      sendFunction={props?.sendFunction}
                      notTyping={props?.notTyping}
                      message={props?.message}
                      setMessage={props?.setMessage}
                      extraFooterStyle={` messageContainerInsidePadding left0 `}
                      showFirstMessage={showFirstMessage}
                      sendContact={props?.sendContact}
                    />
                  )}
                  <p
                    className={`inputError mr-[10px] preserveWhiteThemeColor ${styles.serverError}`}
                  >
                    {props?.serverError}
                  </p>
                </>
              ) : (
                <>
                  {!showFirstMessage &&
                    props?.activeUser?.block &&
                    props?.activeUser?.block == 1 && (
                      <div
                        className={`linkStyle text-center footer__border blockFooter `}
                      >
                        <p onClick={() => unBlockFunction()}>
                          {content?.chatFooter?.unBlock}
                        </p>
                      </div>
                    )}

                  {!showFirstMessage &&
                    !props?.activeUser?.block &&
                    props?.activeUser?.block != 0 && (
                      <Loader
                        className={`lds_ring ${styles.extraLoadingStyle}`}
                        // width={width}
                        // height={height}
                      />
                    )}
                </>
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          // className={` chat__main ${
          //   ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
          // }`}
          className={`chat__main seperatorTop ${
            !isMobile &&
            (direction == 'rtl' ? 'seperatorRight' : 'seperatorLeft')
          }`}
          style={{
            // backgroundImage: `url(${ChooseBackground(bg)?.src})`,
            // // backgroundSize: '200px',
            // // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
            // backgroundSize: ChooseBackground(bg)?.cover
            //   ? 'cover'
            //   : `${SHARED.maxBgScale * backScale}px`,
            height: `100%`,
            position: 'relative',
          }}
        >
          <div
            className={` ${styles.absoluteBg} darkMode ${
              ChooseBackground(bg)?.repeat ? 'repeatBg' : 'noRepeatBg'
            }`}
            style={{
              backgroundImage: `url(${ChooseBackground(bg)?.src})`,
              // backgroundSize: '200px',
              // backgroundSize: `${SHARED.maxBgScale * backScale}px`,
              backgroundSize: ChooseBackground(bg)?.cover
                ? 'cover'
                : `${SHARED.maxBgScale * backScale}px`,
              // height: `100%`,
            }}
          ></div>
          <div
            className={`messageContainerShadow flex flex-row justify-center items-center `}
          >
            <p className={`mx-auto noContent`}>{content?.noContent}</p>
          </div>
        </div>
      )}
      {showFirstMessage && (
        <CenterModal
          handleShowModal={() => {
            setShowFirstMessage('');
            setUserChannelId(previousChannelId);
            props?.setMessage('');
            setSharedUserClicked();
            // setShowSearch(false);
          }}
          extraContentStyle={`firstMessageModal modalContent`}
        >
          <div className={`inputContainerModal`}>
            <p>
              {`${props?.content?.startConversationTo}
   : ${sharedUserClicked}
              `}
            </p>
            <ChatFooter
              ref={ref}
              setServerError={props?.setServerError}
              fileType={props?.fileType}
              loadingFile={props?.loadingFile}
              setLoadingFile={props?.setLoadingFile}
              loadingFileButton={props?.loadingFileButton}
              setLoadingFileButton={props?.setLoadingFileButton}
              setLoadingOldMessages={props?.setLoadingOldMessages}
              setTypingStatus={props?.setTypingStatus}
              users={props?.users}
              chatTypePrivate={props?.chatTypePrivate}
              replyValue={props?.replyValue}
              setReplyValue={props?.setReplyValue}
              content={props?.content}
              setMessages={props?.setMessages}
              fromSearch={true}
              handleSendMessage={props?.handleSendMessage}
              sendFunction={props?.sendFunction}
              notTyping={props?.notTyping}
              message={props?.message}
              setMessage={props?.setMessage}
              // handleSendMessage={props?.handleSendMessage}
              sendFunction={props?.sendFunction}
              notTyping={props?.notTyping}
              message={props?.message}
              setMessage={props?.setMessage}
              extraFooterStyle={`relativeFooter `}
              showFirstMessage={showFirstMessage}
              sendContact={props?.sendContact}
              // dragActive={dragActive}
            />
          </div>
        </CenterModal>
      )}
    </div>
  );
});

export default ChatPage;
